import { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const PatientMapRosterTableOpport = ({
  data = [],
  searchTerm = "",
  loading,
  total,
  page,
  pageSize,
  setPage,
  setPageSize,
  onSelectPatient
}) => {
  const rows = useMemo(() => {
    return data;
  }, [data, searchTerm]);

  const columns = useMemo(() => [
    { field: "TimeStamp", headerName: "TimeStamp", flex: 3, filterable: false },
    {
      field: "RelatedSystemicBillingReview",
      headerName: "Related Systemic Billing Review",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const count = params.row.RelatedSystemicBillingReview?.length ?? 0;
        return `Audit Charts (${count})`;
      }
    },
    { field: "Staff", headerName: "Staff", flex: 2, filterable: false },
    
  ], [onSelectPatient]);

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ minWidth: "1000px" }}>
        <DataGrid
          getRowId={(row) => `${row.MemberID}`}
          rows={rows}
          columns={columns}
          rowCount={total}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          disableColumnFilter
          disableColumnSelector
          loading={loading}
          onRowClick={(params) => onSelectPatient(params.row)}
        />
      </div>
    </div>
  );
};

export default PatientMapRosterTableOpport;
